import React from 'react'
import './about.css'
import Pro from '../../image/programmer.jpg'
import award from '../../image/award.png'

function About() {
  return (
    <div className="a">
      <div className="a-left">
        <div className="a-card bg"></div>
        <div className="a-card">
          <img className="a-img" src={Pro} alt="" />
        </div>
      </div>
      <div className="a-right">
        <h1 className="a-title">About</h1>
        <p className="a-sub">
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sunt, exercitationem.
        </p>
        <p className="a-desc">
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Suscipit libero totam molestiae fugiat ipsa, nesciunt labore ab error quam minima doloribus nemo velit dolor corporis est illum impedit exercitationem repudiandae reiciendis odio officiis magni id distinctio. Cumque culpa facilis quo! Minus ullam doloremque aliquam maxime ipsam rerum voluptas quae est?
        </p>
        <div className="a-award">
          <img src={award} alt="award" className="a-award-img" />
          <div className="a-award-text">
            <h4 className="a-award-title">Lorem, ipsum dolor.</h4>
            <p className="a-award-disc">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Harum dolor dolorum vel magnam natus ad facilis, nisi numquam neque? Quisquam eveniet magnam praesentium necessitatibus velit dicta assumenda ipsam ad magni.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
